"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MerryGoRound = _interopRequireDefault(require("../MerryGoRound"));

var _background = _interopRequireDefault(require("./background.jpg"));

var _Certificate = _interopRequireDefault(require("./Certificate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      width: 300
    },
    margin: {
      height: theme.spacing(3)
    },
    sideBarRoot: {
      backgroundColor: theme.palette.grey[700],
      textAlign: "center",
      minWidth: "40%"
    },
    sideBarHeader: {
      fontWeight: 300,
      padding: theme.spacing(3)
    },
    sideBarBody: {
      background: theme.palette.background.paper
    },
    sideBarAward: {
      padding: theme.spacing(8)
    },
    sideBarFooter: {
      padding: theme.spacing(4),
      color: theme.palette.background.paper
    },
    divider: {
      background: theme.palette.common.white,
      opacity: .45
    },
    sideBarImage: {
      maxHeight: "50vh",
      maxWidth: "100%"
    }
  };
});
/**
 * Moment to display achievements.
 */

function AwardMoment(props) {
  var data = props.data,
      name = props.name;
  var classes = useStyles();

  var renderCertificates = function renderCertificates() {
    return data.map(function (award) {
      return _react.default.createElement(_Certificate.default, _extends({
        name: name
      }, award));
    });
  };

  var renderSideBarContent = function renderSideBarContent(award) {
    if (!award) return;
    var _award$props = award.props,
        color = _award$props.color,
        conferred_by = _award$props.conferred_by,
        image = _award$props.image,
        label = _award$props.label,
        website = _award$props.website;
    return _react.default.createElement(_core.Grid, {
      container: true,
      spacing: 5,
      justify: "center"
    }, _react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      className: classes.sideBarBody
    }, _react.default.createElement(_core.Grid, {
      container: true,
      justify: "center",
      spacing: 5
    }, _react.default.createElement(_core.Grid, {
      item: true,
      xs: 12
    }, _react.default.createElement(_core.Typography, {
      variant: "h4",
      className: classes.sideBarHeader
    }, label), _react.default.createElement(_core.Divider, {
      variant: "middle"
    }), _react.default.createElement("div", {
      className: classes.sideBarAward
    }, award), _react.default.createElement(_core.Divider, {
      variant: "middle"
    })), image && _react.default.createElement(_core.Grid, {
      item: true,
      xs: 10
    }, _react.default.createElement("img", {
      className: classes.sideBarImage,
      src: image,
      alt: "Image of ".concat(label)
    })), website && _react.default.createElement(_core.Grid, {
      item: true,
      xs: 10
    }, _react.default.createElement(_core.Button, {
      style: {
        background: color.light
      },
      target: "_blank",
      href: website,
      variant: "contained"
    }, "Learn More")))), conferred_by && _react.default.createElement(_core.Grid, {
      item: true,
      className: classes.sideBarFooter
    }, _react.default.createElement(_core.Typography, {
      variant: "h6",
      color: "palette.common.white"
    }, "This Award is Presented by ", conferred_by.label), _react.default.createElement(_core.Divider, {
      className: classes.divider
    }), _react.default.createElement(_core.Typography, {
      variant: "overline",
      color: "palette.background.paper"
    }, conferred_by.description)));
  };

  var style = {
    minHeight: "80vh",
    backgroundSize: "cover",
    backgroundPositionY: "57%",
    width: "100%",
    backgroundImage: "url(".concat(_background.default, ")")
  };
  return _react.default.createElement(_MerryGoRound.default, _extends({}, props, {
    sideBarClassName: classes.sideBarRoot,
    sideBarContent: renderSideBarContent,
    style: style
  }), renderCertificates());
}

AwardMoment.propTypes = {
  /** Determines the background and text color of the `Moment` header. */
  color: _propTypes.default.shape({
    background: _propTypes.default.string,
    text: _propTypes.default.string
  }),

  /** Information to build the `AwardCertificate`s */
  data: _propTypes.default.array.isRequired,

  /** Determines the `SideBarSection` `Icon` of the `Moment`. */
  icon: _propTypes.default.element,

  /** Used to serialize the order of the `Moment`s in a `Story` */
  index: _propTypes.default.number,

  /** Determines the `SideBarSection` text of the `Moment`. */
  label: _propTypes.default.string,

  /** Determines the name written on the `AwardCertificate`s. */
  name: _propTypes.default.string,

  /** Paragraph text underneath the title in `Moment` header */
  subtitle: _propTypes.default.string,

  /** Main heading element of the `Moment` */
  title: _propTypes.default.node,

  /** The type of `Moment` */
  type: _propTypes.default.string
};
AwardMoment.defaultProps = {
  type: "award"
};
var _default = AwardMoment;
exports.default = _default;